import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconListAdd: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="list-add, list-plus, new-list"><path d="M3.75 6H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 12H10.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 18H10.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M14.75 14.75L21.25 14.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M18 11.75V18.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconListAdd;
